module.exports = __webpack_public_path__ + "img/hong_kong_2016_3.f5096993.png";